import { isNumber } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { BUSINESS_TRIGGER_CTA, CtaData } from '../types';
import { FIB_SUCCESS_REGISTRATION_URL_FLAG, CTA_DATA_FLAG } from './SuccessModalState';

export const buildRedirectQueryParameters = (data: {
    redirectUrl?: string;
    source?: string;
    type?: BUSINESS_TRIGGER_CTA;
    ctaData?: CtaData;
    balanceInUsdCents?: number;
}) => {
    const { url: contextUrl } = getContext();
    const { balanceInUsdCents = 0, redirectUrl } = data;
    const { pathname, search } = contextUrl ? new URL(contextUrl) : window.location;
    const url = redirectUrl
        ? new URL(redirectUrl, window.location.origin)
        : new URL(pathname + search, window.location.origin);
    url.searchParams.set(FIB_SUCCESS_REGISTRATION_URL_FLAG, data.type || 'true');

    if (data.source) {
        url.searchParams.set('source', data.source);
    }

    if (data.ctaData && typeof data.ctaData === 'object') {
        url.searchParams.set(CTA_DATA_FLAG, JSON.stringify(data.ctaData));
    }

    if (isNumber(balanceInUsdCents) && balanceInUsdCents > 0) {
        // README: Need for "appcues" to show explanation for the balance after migration
        url.searchParams.set('welcome_modal', 'migrated_balanced');
    }

    return url.toString();
};
